import { QueryModel } from 'models/common';

export const AuthQuery = {
  login: {
    apiUrl: '/auth/login',
    method: 'POST',
  },
} satisfies QueryModel;
